import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../../helpers/auth';

const PrivateRoute = ({ children }) => {
  const auth = isLoggedIn();
  return auth ? children : <Navigate replace to="/login" />;
};

export default PrivateRoute;
